import * as ActionTypes from '../constants/actionTypes';

export const initialState = {
    request: false,
    error: '',
    data: {},
    isModelsOpen: false,
};

export default function models(state = initialState, action) {

    switch (action.type) {
        case ActionTypes.MODELS_REQUEST:
            return {
                ...state,
                request: true,
                error: '',
            };

        case ActionTypes.MODELS_SUCCESS:
            return {
                ...state,
                request: false,
                error: '',
                data: action.payload
            };

        case ActionTypes.MODELS_ERROR:
            return {
                ...state,
                request: false,
                error: action.payload
            };
        case ActionTypes.TOGGLE_MODELS_MODEL:
            return {
                ...state,
                isModelsOpen: action.payload,
            };

        default :
            return state;
    }

}